import React, { useEffect, useState } from 'react';
import { useTheme } from "@material-ui/core/styles";
import PropTypes from 'prop-types';

const TakisPicture = ({pictureClass, images, isLazy, altText, tabletBp, desktopBp}) => {
    const [onLandscape, setOnLandscape] = useState(window.matchMedia("(orientation: landscape)").matches)

    useEffect(() => {
        window.addEventListener("resize", () => {
            setOnLandscape(window.matchMedia("(orientation: landscape)").matches)
        })
    }, [])

    const theme = useTheme();
    const selectBp = (breakpoint) => {
        switch(breakpoint){
            case "sm":
                return theme.breakpoints.values.sm
            case "md":
                return theme.breakpoints.values.md
            case "lg":
                return theme.breakpoints.values.lg
            case "xl":
                return theme.breakpoints.values.xl
            default:
                return false
        }
    };
    const tablet = selectBp(tabletBp) || theme.breakpoints.values.md;
    const desktop = selectBp(desktopBp) || theme.breakpoints.values.lg;

    const mobileImg = images.find(element => element.size === "mobile");
    const tabletImg = images.find(element => element.size === "tablet");
    const desktopImg = images.find(element => element.size === "desktop");
    return (
        <picture className={pictureClass}>
            {desktopImg && <source media={`(min-width:${desktop}px)`} srcSet={desktopImg?.url}/>}
            {onLandscape && <source media={`(min-width:${desktop}px)`} srcSet={desktopImg?.url}/>}
            {tabletImg && <source media={`(min-width:${tablet}px)`} srcSet={tabletImg?.url}/>}
            {mobileImg && <img src={mobileImg.url} alt={altText} className={pictureClass} loading={`${isLazy?'lazy':''}`}></img>}
        </picture>
    );
}

TakisPicture.propTypes = {
    pictureClass: PropTypes.string,
    images: PropTypes.array,
    isLazy: PropTypes.bool,
    tabletBp: PropTypes.string,
    desktopBp: PropTypes.string,
    altText: PropTypes.string
}

export default TakisPicture;
